<template>
  <div class="base-time-picker"
       :class="timePickerStyles">
    <time-picker-button class="time-button"
                        v-show="value - 15 >= 0"
                        @click="addTime(-15)">
      -15{{ $t("minutesAbbrev") }}
    </time-picker-button>

    <div class="time-input-wrapper">
      <label class="time-picker-label">
        <input class="time-picker-input"
               :value="maskedHours"
               v-imask="hoursMask"
               type="text"
               inputmode="numeric"
               ref="hoursInput"
               @accept="setMaskedHours"
               @change="correctMask">
        {{ $t("hoursAbbrev") }}
      </label>
      <label class="time-picker-label">
        <input class="time-picker-input"
               :value="maskedMinutes"
               v-imask="minutesMask"
               type="text"
               inputmode="numeric"
               ref="minutesInput"
               @accept="setMaskedMinutes"
               @change="correctMask">
        {{ $t("minutesAbbrev") }}
      </label>
    </div>

    <time-picker-button class="time-button"
                        v-show="value + 15 <= 1440"
                        @click="addTime(15)">
      +15{{ $t("minutesAbbrev") }}
    </time-picker-button>
  </div>
</template>

<script>
  import TimePickerButton from './BaseTimePickerButton.vue'
  import { getTimeString } from '@/services/utils.js'

  export default {
    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      value: {
        required: true,
        type: Number
      }
    },

    components: {
      TimePickerButton
    },

    data() {
      return {
        hours: 0,
        minutes: 0,
        maskedHours: '00',
        maskedMinutes: '00',
        hoursMask: {
          mask: /^(2[0-4]|[01]?[0-9])$/,
          lazy: false
        },

        minutesMask: {
          mask: /^([0-5]?[0-9])$/,
          lazy: false
        },
      }
    },

    methods: {
      setMaskedHours(event) {
        this.maskedHours = event.target.value
        this.hours = +this.maskedHours

        if (this.hours === 24 || this.minutes > 0) {
          this.$refs.minutesInput.maskRef.typedValue = '00'
          this.minutes = 0
        }

        this.setFullTime()
      },

      setMaskedMinutes(event) {
        let maskedMinutes = event.target.value
        let minutes = +maskedMinutes

        if (this.hours === 24 && minutes > 0) {
          this.$refs.minutesInput.maskRef.typedValue = '00'
          this.minutes = 0
        } else {
          this.maskedMinutes = maskedMinutes
          this.minutes = minutes
        }

        this.setFullTime()
      },

      correctMask(event) {
        let value = +event.target.value

        if (value >= 10) {
          return
        }

        event.target.maskRef.typedValue = `0${value}`
      },

      setFullTime() {
        this.$emit('change', this.hours * 60 + this.minutes)
      },

      addTime(timeInMinutes) {
        this.$emit('change', this.value + timeInMinutes)
      }
    },

    computed: {
      timePickerStyles() {
        return {
          'base-time-picker-mobile': this.$mq === 'mobile'
        }
      }
    },

    watch: {
      value: {
        handler() {
          let hours = Math.floor(this.value / 60)
          let minutes = this.value % 60

          if (this.hours !== hours) {
            this.hours = hours

            let maskedHours = getTimeString(this.hours)

            if (this.$refs.hoursInput) {
              this.$refs.hoursInput.maskRef.typedValue = maskedHours
            } else {
              this.maskedHours = maskedHours
            }
          }

          if (this.minutes !== minutes) {
            this.minutes = minutes

            let maskedMinutes = getTimeString(this.minutes)

            if (this.$refs.minutesInput) {
              this.$refs.minutesInput.maskRef.typedValue = maskedMinutes
            } else {
              this.maskedMinutes = maskedMinutes
            }
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .base-time-picker {
    position: relative;
  }

  .time-input-wrapper {
    display: flex;
  }

  .time-picker-label {
    display: flex;
    align-items: baseline;
    font-size: 47px;
    font-weight: bold;
    color: map.get($colors, primary);
    user-select: none;

    &:first-child {
      margin-right: 9px;
    }
  }

  .time-picker-input {
    width: 60px;
    font: inherit;
    color: inherit;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid map.get($colors, primary);
  }

  .time-button {
    position: absolute;
    top: 0;

    &:first-child {
      right: calc(100% + 24px);
    }

    &:last-child {
      left: calc(100% + 24px);
    }
  }

  .base-time-picker-mobile {
    .time-input-wrapper {
      .time-picker-label {
        font-size: 35px;

        .time-picker-input {
          width: 45px;
        }
      } 
    }

    .time-button {
      position: absolute;
      top: 0;

      &:first-child {
        right: calc(100% + 15px);
      }

      &:last-child {
        left: calc(100% + 15px);
      }
    }
  }
</style>
